<app-view-item
  *ngIf="readonly"
  [text]="value"
  [borderless]="borderless"
></app-view-item>

<input
  *ngIf="!readonly"
  nz-input
  [ngModel]="value"
  (ngModelChange)="onModelChange($event)"
  [readOnly]="readonly"
  (keydown)="onKeydown($event)"
  (keyup)="onKeyUp($event)"
  (paste)="onPaste($event)"
  autocorrect="off"
  autocomplete="off"
  spellcheck="false"
  [class]="readonly && !borderless ? 'bg-grey-lighter' : ''"
  maxlength="5"
  (click)="onClick($event.target)"
/>